import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59cd6210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}, " You have TB? ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "500"
}, " You need more information? ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "1000"
}, " Need some company and support for your therapy? ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "1500"
}, " Anonymous and free of charge? ", -1))
const _hoisted_7 = {
  class: "caret-slot",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "2000"
}
const _hoisted_8 = {
  key: 0,
  class: "text-large",
  "data-aos": "flip-right",
  "data-aos-easing": "ease",
  "data-aos-delay": "300"
}
const _hoisted_9 = {
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}
const _hoisted_10 = { class: "col-left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right-huge" }, " Choose your companion and get started. ")
], -1))
const _hoisted_12 = {
  "data-aos": "zoom-in",
  "data-aos-easing": "ease"
}
const _hoisted_13 = { class: "col-left" }
const _hoisted_14 = {
  "data-aos": "zoom-in",
  "data-aos-easing": "ease"
}
const _hoisted_15 = { class: "col-right" }
const _hoisted_16 = { class: "col-companions" }
const _hoisted_17 = { class: "col-companions" }
const _hoisted_18 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_19 = { class: "col-left" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-1" }, " Virtual support, if you are feeling lonely or afraid. ")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-2" }, " Setup your therapy period to watch your progress. ")
], -1))
const _hoisted_22 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_23 = { class: "col-left" }
const _hoisted_24 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_25 = { class: "col-left" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-3" }, " Enter your medication plan. ")
], -1))
const _hoisted_27 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_28 = { class: "screen-text-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_32 = { class: "col-left" }
const _hoisted_33 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_34 = { class: "col-left" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-5" }, " Tracks progress and supports you even with legal advice during TB treatment. ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-6" }, " Information about TB disease in general. ")
], -1))
const _hoisted_37 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_38 = { class: "col-left" }
const _hoisted_39 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_40 = { class: "col-left" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-7" }, " Information on how to get cured and how to protect others. ")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-8" }, [
    /*#__PURE__*/_createTextVNode(" Check your complete chat history."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Opt-out anytime you want. ")
  ])
], -1))
const _hoisted_43 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_44 = { class: "col-left" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "flip-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right" }, " Interested? ")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right" }, " Ask your healthcare worker in this institution or look for TB Companion on Apple App Store or Google Play. ")
], -1))
const _hoisted_47 = {
  href: "https://play.google.com/store/apps/details?id=app.tbcompanion",
  target: "_blank"
}
const _hoisted_48 = {
  href: "https://apps.apple.com/us/app/tb-companion/id1556445437",
  target: "_blank"
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}, " Aveți tuberculoză? ", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "500"
}, " Aveți nevoie de mai multe informații? ", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "1000"
}, " Aveți nevoie de companie și susținere pe timpul terapiei? ", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "1500"
}, " Anonim și fără niciun cost? ", -1))
const _hoisted_54 = {
  class: "caret-slot",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "2000"
}
const _hoisted_55 = {
  key: 0,
  class: "text-large",
  "data-aos": "flip-right",
  "data-aos-easing": "ease",
  "data-aos-delay": "2000"
}
const _hoisted_56 = {
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}
const _hoisted_57 = { class: "col-left" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right-huge" }, " Alegeți-vă partenerul și începeți. ")
], -1))
const _hoisted_59 = {
  "data-aos": "zoom-in",
  "data-aos-easing": "ease"
}
const _hoisted_60 = { class: "col-left" }
const _hoisted_61 = {
  "data-aos": "zoom-in",
  "data-aos-easing": "ease"
}
const _hoisted_62 = { class: "col-right" }
const _hoisted_63 = { class: "col-companions" }
const _hoisted_64 = { class: "col-companions" }
const _hoisted_65 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_66 = { class: "col-left" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-1" }, " Susținere virtuală dacă vă simțiți singur/ă. ")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-2" }, " Configurați perioada de terapie pentru a vă urmări progresul. ")
], -1))
const _hoisted_69 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_70 = { class: "col-left" }
const _hoisted_71 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_72 = { class: "col-left" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-3" }, " Introduceți planul de medicamente. ")
], -1))
const _hoisted_74 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_75 = { class: "screen-text-4" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_78 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_79 = { class: "col-left" }
const _hoisted_80 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_81 = { class: "col-left" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-5" }, " Urmărește progresul și vă sprijină chiar și cu sfaturi juridice în timpul tratamentului de tuberculoză. ")
], -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-6" }, " Informații generale despre tuberculoză. ")
], -1))
const _hoisted_84 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_85 = { class: "col-left" }
const _hoisted_86 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_87 = { class: "col-left" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-7" }, " Informații despre cum să vă vindecați și cum să-i protejați pe ceilalți. ")
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-8" }, [
    /*#__PURE__*/_createTextVNode(" Verificați istoricul complet al conversațiilor."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Renunțați oricând doriți. ")
  ])
], -1))
const _hoisted_90 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_91 = { class: "col-left" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "flip-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right" }, " Interesat/ă? ")
], -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right" }, " Adresați-vă personalului medical din această instituție sau căutați TB Companion în Apple App Store sau Google Play. ")
], -1))
const _hoisted_94 = {
  href: "https://play.google.com/store/apps/details?id=app.tbcompanion",
  target: "_blank"
}
const _hoisted_95 = {
  href: "https://apps.apple.com/us/app/tb-companion/id1556445437",
  target: "_blank"
}
const _hoisted_96 = { key: 2 }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}, " Захворів на туберкульоз? ", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "500"
}, " Вам потрібно більше інформації? ", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "1000"
}, " Потрібна компанія та підтримка під час лікування? ", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-medium",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "1500"
}, " Бажаєте зробити це анонімно і безкоштовно? ", -1))
const _hoisted_101 = {
  class: "caret-slot",
  "data-aos": "fade-up",
  "data-aos-easing": "ease",
  "data-aos-delay": "2000"
}
const _hoisted_102 = {
  key: 0,
  class: "text-large",
  "data-aos": "flip-right",
  "data-aos-easing": "ease",
  "data-aos-delay": "2000"
}
const _hoisted_103 = {
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}
const _hoisted_104 = { class: "col-left" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right-huge" }, " Оберіть свого компаньйона і починайте. ")
], -1))
const _hoisted_106 = {
  "data-aos": "zoom-in",
  "data-aos-easing": "ease"
}
const _hoisted_107 = { class: "col-left" }
const _hoisted_108 = {
  "data-aos": "zoom-in",
  "data-aos-easing": "ease"
}
const _hoisted_109 = { class: "col-right" }
const _hoisted_110 = { class: "col-companions" }
const _hoisted_111 = { class: "col-companions" }
const _hoisted_112 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_113 = { class: "col-left" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-1" }, " Якщо ви відчуваєте самотність або страх, ви можете отримати віртуальну підтримку. ")
], -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-2" }, " Налаштуйте період лікування і спостерігайте за прогресом. ")
], -1))
const _hoisted_116 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_117 = { class: "col-left" }
const _hoisted_118 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_119 = { class: "col-left" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-3" }, " Введіть свій план лікування. ")
], -1))
const _hoisted_121 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_122 = { class: "screen-text-4" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_125 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_126 = { class: "col-left" }
const _hoisted_127 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_128 = { class: "col-left" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-5" }, " Під час лікування туберкульозу ви можете відстежувати результат і навіть отримувати юридичну підтримку. ")
], -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-6" }, " Загальна інформація про захворювання на туберкульоз. ")
], -1))
const _hoisted_131 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_132 = { class: "col-left" }
const _hoisted_133 = {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}
const _hoisted_134 = { class: "col-left" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-7" }, " нформація про те, як вилікуватися та як захистити інших. ")
], -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "screen-text-8" }, [
    /*#__PURE__*/_createTextVNode(" Ви можете переглядати всю хронологію чату."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Відмовитися можна будь-коли. ")
  ])
], -1))
const _hoisted_137 = {
  "data-aos": "fade-up-left",
  "data-aos-easing": "ease"
}
const _hoisted_138 = { class: "col-left" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "flip-right",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right" }, " Зацікавились? ")
], -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-aos": "fade-up",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-right" }, " Запитайте свого медичного працівника в цій установі або знайдіть проект TB Companion у додатках Apple App Store або Google Play. ")
], -1))
const _hoisted_141 = {
  href: "https://play.google.com/store/apps/details?id=app.tbcompanion",
  target: "_blank"
}
const _hoisted_142 = {
  href: "https://apps.apple.com/us/app/tb-companion/id1556445437",
  target: "_blank"
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bannerimage",
  src: "/banner.png",
  alt: "banner"
}, null, -1))

export function render(_ctx, _cache) {
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Language = _resolveComponent("Language")
  const _component_CaretBottom = _resolveComponent("CaretBottom")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigation),
    _createVNode(_component_Language),
    (_ctx.lang=='en')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.windowWidth > 1000 ? 'content-screen' : 'content')
          }, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_Transition, { name: "el-fade-in-linear" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CaretBottom)
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.showCaret]
                  ])
                ]),
                _: 1
              })
            ]),
            (_ctx.windowWidth > 720)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " AVAILABLE NOW! "))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_image, { src: "/logo_large.png" })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_el_image, { src: "/1_happy.png" })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_row, { class: "info-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 8,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_el_image, { src: "/2_happy.png" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_el_image, {
                          class: "hippo",
                          src: "/3_happy.png"
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_el_image, {
                          class: "tiger",
                          src: "/4_happy.png"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen03.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-2' : 'mobile'),
                          src: "/screen07.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen04.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createTextVNode(" Daily treatment reminders helping you to stay on track. "),
                        _hoisted_29,
                        _hoisted_30,
                        _createVNode(_component_el_image, { src: "/screen11.png" })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-3' : 'mobile'),
                          src: "/screen01.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_el_image, { src: "/screen02.png" })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-2' : 'mobile'),
                          src: "/screen09.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen10.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_42
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen05.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "badge-buttons"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_47, [
                      _createVNode(_component_el_image, {
                        class: "badge",
                        src: "/google-play.png"
                      })
                    ]),
                    _createElementVNode("a", _hoisted_48, [
                      _createVNode(_component_el_image, {
                        class: "badge",
                        src: "/app-store.svg"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.lang=='ro')
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.windowWidth > 1000 ? 'content-screen' : 'content')
          }, [
            _hoisted_50,
            _hoisted_51,
            _hoisted_52,
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_Transition, { name: "el-fade-in-linear" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_icon, { class: "el-icon-caret-bottom" }, null, 512), [
                    [_vShow, _ctx.showCaret]
                  ])
                ]),
                _: 1
              })
            ]),
            (_ctx.windowWidth > 720)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, " DISPONIBIL ACUM! "))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_el_image, { src: "/logo_large.png" })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_el_image, { src: "/1_happy.png" })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_el_col, {
                    span: 8,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_el_image, { src: "/2_happy.png" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_el_image, {
                          class: "hippo",
                          src: "/3_happy.png"
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_el_image, {
                          class: "tiger",
                          src: "/4_happy.png"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen03.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_67
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_68
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-2' : 'mobile'),
                          src: "/screen07.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen04.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_73
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createTextVNode(" Memento-uri de tratament zilnic, care vă ajută să rămâneți pe drumul cel bun. "),
                        _hoisted_76,
                        _hoisted_77,
                        _createVNode(_component_el_image, { src: "/screen11.png" })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-3' : 'mobile'),
                          src: "/screen01.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(_component_el_image, { src: "/screen02.png" })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_82
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_83
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("div", _hoisted_85, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-2' : 'mobile'),
                          src: "/screen09.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen10.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_88
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_89
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen05.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_92
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_93
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "badge-buttons"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_94, [
                      _createVNode(_component_el_image, {
                        class: "badge",
                        src: "/google-play.png"
                      })
                    ]),
                    _createElementVNode("a", _hoisted_95, [
                      _createVNode(_component_el_image, {
                        class: "badge",
                        src: "/app-store.svg"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.lang=='uk')
      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.windowWidth > 1000 ? 'content-screen' : 'content')
          }, [
            _hoisted_97,
            _hoisted_98,
            _hoisted_99,
            _hoisted_100,
            _createElementVNode("div", _hoisted_101, [
              _createVNode(_Transition, { name: "el-fade-in-linear" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_icon, { class: "el-icon-caret-bottom" }, null, 512), [
                    [_vShow, _ctx.showCaret]
                  ])
                ]),
                _: 1
              })
            ]),
            (_ctx.windowWidth > 720)
              ? (_openBlock(), _createElementBlock("div", _hoisted_102, " ЗАРАЗ ВСЕ це є! "))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _createVNode(_component_el_image, { src: "/logo_large.png" })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_105
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createVNode(_component_el_image, { src: "/1_happy.png" })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_108, [
                  _createVNode(_component_el_col, {
                    span: 8,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_109, [
                        _createVNode(_component_el_image, { src: "/2_happy.png" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_110, [
                        _createVNode(_component_el_image, {
                          class: "hippo",
                          src: "/3_happy.png"
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    class: "info-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_111, [
                        _createVNode(_component_el_image, {
                          class: "tiger",
                          src: "/4_happy.png"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("div", _hoisted_113, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen03.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_114
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_115
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("div", _hoisted_117, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-2' : 'mobile'),
                          src: "/screen07.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("div", _hoisted_119, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen04.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_120
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_121, [
                      _createElementVNode("div", _hoisted_122, [
                        _createTextVNode(" Щоденні нагадування про лікування допоможуть триматися заданого курсу. "),
                        _hoisted_123,
                        _hoisted_124,
                        _createVNode(_component_el_image, { src: "/screen11.png" })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-3' : 'mobile'),
                          src: "/screen01.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, [
                        _createVNode(_component_el_image, { src: "/screen02.png" })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_129
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_130
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("div", _hoisted_132, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop-2' : 'mobile'),
                          src: "/screen09.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("div", _hoisted_134, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen10.png"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_135
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_136
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_137, [
                      _createElementVNode("div", _hoisted_138, [
                        _createVNode(_component_el_image, {
                          class: _normalizeClass(_ctx.windowWidth > 1000 ? 'desktop' : 'mobile'),
                          src: "/screen05.jpg"
                        }, null, 8, ["class"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_139
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "info-col"
                }, {
                  default: _withCtx(() => [
                    _hoisted_140
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "info-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "badge-buttons"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_141, [
                      _createVNode(_component_el_image, {
                        class: "badge",
                        src: "/google-play.png"
                      })
                    ]),
                    _createElementVNode("a", _hoisted_142, [
                      _createVNode(_component_el_image, {
                        class: "badge",
                        src: "/app-store.svg"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _hoisted_143
  ]))
}